import React from 'react'

const ProcessCard = ({ title, content, lcolor, icon: Icon }) => {
  return (
    <div className="bg-white dark:bg-gray-700 shadow-lg rounded-lg p-5 border border-gray-200 dark:border-gray-600 hover:shadow-xl transition">
      <h3 className="flex items-center gap-2 font-bold text-lg text-gray-900 dark:text-gray-100">
        {Icon && <Icon size={22} className={`${lcolor}`} />}{title}
      </h3>
      <p className="mt-2 text-gray-600 dark:text-gray-200">{content}</p>
    </div>
  )
}

export default ProcessCard
